import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import * as confirmAction from "../../../store/confirm/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";
import * as actualSupplyDemandListAction from "../../../store/report-actual-supply-demand/action";

import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import {
  GET_ACTUAL_SUPPLY_DEMAND_REPORT,
  SEND_MAIL_ACTUAL_SUPPLY_DEMAND,
  baseUrl,
} from "../../../helpers/url_api_constant";
import { Link, useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";
import { post, postUpload } from "../../../helpers/api_helper";
import BootstrapTable from "react-bootstrap-table-next";
import { DatePicker } from "antd";
import Flatpickr from "react-flatpickr";
import OverButton from "../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import Select from "react-select";
import classnames from "classnames";
import { connect, useSelector } from "react-redux";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import { useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom';
import { withTranslation } from "react-i18next";

const generateYearList = () => {
  const currentYear = new Date().getFullYear();
  let years = [];
  for (let index = currentYear - 4; index <= currentYear; index++) {
    years.push({ label: index, value: index });
  }
  return years;
};
const currentYear = new Date().getFullYear();


function ActualSupplyDemand(props) {
  let history = useHistory();
  const dispatch = useDispatch();
  const permission = getPermission();
  const location = useLocation();
  const actualSupplyDemandReportListReducer = useSelector(state => state.ActualSupplyDemandReportList);
  const searchObj = location?.state?.goBack == true ? actualSupplyDemandReportListReducer.modelSearch : { FLOW_YEAR: currentYear };
  const [searchModel, setSearchModel] = useState(searchObj);
  const [modelDeviceList, setModelDeviceList] = useState(location?.state?.goBack == true ? actualSupplyDemandReportListReducer.modelDeviceList : []);
  const [listYear, setListYear] = useState(generateYearList());

  // DropDown Search
  const [dropDownSearchYear, setDropDownSearchYear] = useState(location?.state?.goBack == true ? actualSupplyDemandReportListReducer.dropDownSearchYear : {
    label: currentYear,
    value: currentYear
  });
  // DropDown Search

  // Handle Set Value DropDown Search //
  const handleSelectDropDownSearchYear = selected => {
    setDropDownSearchYear(selected);
  };
  // Handle Set Value DropDown Search //

  useEffect(() => {
    dispatch(actualSupplyDemandListAction.setModelDeviceListToState(modelDeviceList))
  }, [modelDeviceList])

  //sort Column//
  const defaultSorted = [
    {
      dataField: "MONTH_DATA",
      order: "desc",
    },
  ];
  //sort Column//

  //Sort Page//
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total ms-2">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    page: location?.state?.goBack == true ? actualSupplyDemandReportListReducer.pagination.page : 1,
    sizePerPage: location?.state?.goBack == true ? actualSupplyDemandReportListReducer.pagination.sizePerPage : 100,
    onSizePerPageChange: (sizePerPage, page) => {
      dispatch(actualSupplyDemandListAction.setPaginationToState({ sizePerPage, page }))
    },
    onPageChange: (page, sizePerPage) => {
      dispatch(actualSupplyDemandListAction.setPaginationToState({ sizePerPage, page }))
    },
    paginationSize: 4,
    pageStartIndex: 1,

    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "100",
        value: 100,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "750",
        value: 750,
      },
      {
        text: "1000",
        value: 1000,
      },
    ],
  };
  //Sort Page//

  // Action Button//
  const ButtonAction = (cellContent, row) => {
    // console.log(row)
    return (
      <div>
        {permission.vASD && (
          <>
            <OverButton
              onClick={() => {
                gotoPageActualSupplyDetail(row);
              }}
              color="primary"
              icon="fas fa-eye"
              label="View Detail"
            />
            <OverButton
              onClick={() => {
                downloadExcel(row);
              }}
              color="success"
              icon="fas fa-file-download fa-lg"
              label="Download Excel"
            />
          </>
        )}

        {permission.eASD && (
          <>
            <OverButton
              onClick={() => {
                dispatch(
                  confirmAction.showConfirm(
                    "Do you want to send e-mail ?",
                    () => {
                      sendMail(row);
                    }
                  )
                );
              }}
              // onClick={() => {
              //   sendMail(row);
              // }}
              color="info"
              icon="mdi mdi-email-send fa-lg"
              label="Send E-mail"
            />
          </>
        )}

      </div>
    );
  };

  const gotoPageActualSupplyDetail = row => {
    // console.log(row);
    history.push("/actual-supply-demand-actual-gsm/" + row.MONTH_DATA + "/actual-supply-demand-actual-gsm-detail");
  };

  const downloadExcel = async (row) => {
    // console.log(row);
    dispatch(loadingAction.showLoading());
    const accessToken = JSON.parse(localStorage.getItem("accessToken"));
    fetch(baseUrl + "api/Report/downloadRPActualSupplyDemandReportFile?ACTUAL_YEARS=" + row.MONTH_DATA, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/vnd.ms-excel',
        'Authorization': "Bearer " + accessToken.access_token,
        'TSOSESSIONID': getUserToken(),
      },
    })
      // fetch("https://tsoopwb.pttplc.com/api/DownloadFile/DownloadBookingFile?szFileName=" + pid , {
      //   method: 'GET',
      //   headers: {
      //     'Content-Type': 'application/vnd.ms-excel',
      //     'Authorization':"Bearer " + accessToken.access_token
      //   },
      // })
      .then((response) => response.blob())
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(
          new Blob([blob]),
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          // `FileName.xlsx`,
          'ActualSupplyDemand' + moment(row.MONTH_DATA).locale('en').format("YYYY-MMM") + '.xlsx'
        );

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
        dispatch(loadingAction.hideLoading());
      });
  };

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = 'white';

    return style;
  };

  //render Index//
  const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
  //render Index//

  //format date 
  const FormatDate = (date, format) => {
    return (
      <div>
        {moment(date).format(
          format
        )}
      </div>
      // Sep-21
    );
  };
  //format date


  const CheckSentMail = (cellContent, row) => {
    let label = "";
    // row.STATUS_EMAIL = 5;
    if (row.STATUS_EMAIL == 0) {
      label = "Wait to send e-mail";
    } else if (row.STATUS_EMAIL == 1) {
      label = "Sending";
    } else if (row.STATUS_EMAIL == 2) {
      label = "Failed to send e-mail";
    } else if (row.STATUS_EMAIL == 3) {
      label = "Send e-mail success";
    } else {
      label = "";
    }

    return (
      <div>
        <label>
          {label}
        </label>
      </div>
    );
  };

  //headerColumn
  const columns = [
    {
      dataField: "Dummy",
      text: "No.",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "5%",
        fontSize: "12px",
      },
      style: {
        width: "5%",
        fontSize: "12px",
      },
      formatter: CountIndexRow,
    },

    {
      dataField: "MONTH_NAME",
      text: "Month",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "25%",
        fontSize: "12px",
      },
      style: {
        width: "25%",
        fontSize: "12px",
      },
      sort: true,
      // isDummyField: true,
      // formatter: (cellContent, row) => FormatDate(row.PERFORMANCE_YEARS, "DD/MM/YYYY"),
    },

    // {
    //   dataField: "STATUS_EMAIL",
    //   text: "Status",
    //   headerAlign: "center",
    //   formatter: CheckSentMail,
    //   align: "center",
    //   headerStyle: {
    //     width: "15%",
    //     fontSize: "12px",
    //   },
    //   style: {
    //     width: "15%",
    //     fontSize: "12px",
    //   },
    //   sort: false,
    // },

    {
      dataField: "df1",
      text: "Action",
      isDummyField: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "5%",
        fontSize: "12px",
      },
      style: {
        width: "5%",
        fontSize: "12px",
      },
      formatter: ButtonAction,
    },
  ];
  //headerColumn

  //onInit//
  useEffect(function () {
    if (location?.state?.goBack != true) {
      resetSearch();
    }
    resetModel();

    let tableId = "actual-supply-demand-report-table";
    let scrollY = 213;
    function fixedTableHeader() {
      let headerTable = document.querySelector(`#${tableId} thead`);
      if (window.scrollY >= scrollY) {
        headerTable.classList.add("fixed-header");

        resizeTableHeader();
      } else {
        headerTable.classList.remove("fixed-header");
      }
    }
    function resizeTableHeader() {
      setTimeout(() => {
        let headerTable = document.querySelector(`#${tableId} thead`);
        let tr = document.querySelector(`#${tableId} tbody tr`);
        let th = headerTable.querySelector(".header-style");
        if (tr) {
          for (var i = 0; i < tr.childNodes.length; i++) {
            th.childNodes[i].style.width = `${tr.childNodes[i].offsetWidth}px`;
          }
        }
      }, 1);
    }
    window.addEventListener("scroll", fixedTableHeader);
    document
      .querySelector(`#vertical-menu-btn`)
      .addEventListener("click", resizeTableHeader);
    return () => {
      window.removeEventListener("scroll", fixedTableHeader);
      document.querySelector(`#vertical-menu-btn`)?.removeEventListener("click", resizeTableHeader);
    };
  }, []);
  //onInit//

  const resetSearch = () => {
    setSearchModel({ FLOW_YEAR: currentYear });
    fetchData({ FLOW_YEAR: currentYear });
  };

  const resetModel = () => {
    // setCreateModel(createObj);
  };

  const onSearch = () => {
    fetchData(searchModel);
  };

  const fetchData = async (searchData) => {
    dispatch(actualSupplyDemandListAction.setSearchToState(searchData))
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(GET_ACTUAL_SUPPLY_DEMAND_REPORT, searchData);
      // console.log(res);
      setModelDeviceList(res.data.map((item) => ({ MONTH_NAME: item, MONTH_DATA: moment(searchData.FLOW_YEAR + "-" + item + "-01").format('YYYY-MM-DD') })));
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  // useEffect(function () {

  //   console.log(modelDeviceList);

  // }, [modelDeviceList]);

  useEffect(function () {
    let FLOW_YEAR = dropDownSearchYear != null ? dropDownSearchYear.value : null;

    setSearchModel(preVent => ({
      ...preVent, FLOW_YEAR: FLOW_YEAR
    }));
    dispatch(actualSupplyDemandListAction.setDropDownSearchYear(dropDownSearchYear))

  }, [dropDownSearchYear]);

  const sendMail = async (data) => {
    // console.log(data);
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(SEND_MAIL_ACTUAL_SUPPLY_DEMAND, { ACTUAL_YEARS: data.MONTH_DATA });
      if (res.resultCode != 200) {
        dispatch(messageAction.showMessage(res.resultDescription));
      } else {
        dispatch(messageAction.showMessage("Sending email."));
        fetchData(searchModel);
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-0">
                    <h1 className="mb-sm-0 font-size-20">
                      {props.t("Actual Supply Demand ( Actual-GSM )")}
                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            Report
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">Actual Supply Demand ( Actual-GSM )</li>
                      </ol>
                    </div>
                  </div>
                </CardBody>
              </Card>

              <Row>
                <Col sm="12">
                  <Card>
                    <CardBody>

                      <Row>
                        <Col sm="4">

                          <FormGroup className="row mt-0">
                            <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                              Report Year
                            </Label>
                            <Col sm={8}>
                              <Select
                                placeholder="Select Year"
                                value={dropDownSearchYear}
                                onChange={handleSelectDropDownSearchYear}
                                options={listYear}
                                classNamePrefix="select2-selection"
                              />
                            </Col>
                          </FormGroup>

                          {/* <FormGroup className="row mt-0">
                            <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                              Report Date
                            </Label>
                            <Col sm={8}>
                              <Flatpickr
                                className="form-control d-block"
                                placeholder="Select Date"
                                options={{
                                  altInput: true,
                                  // altFormat: "d/m/Y",
                                  altFormat: "d/m/Y",
                                  dateFormat: "d/m/Y",
                                }}
                                onChange={(value) => {
                                  setSearchModel(
                                    {
                                      ...searchModel,
                                      SUMMARYREPORT_DATE: value[0]

                                    })

                                }}
                                value={searchModel.SUMMARYREPORT_DATE}
                              />
                            </Col>
                          </FormGroup> */}


                        </Col>


                        {/* <Col sm="4">
                          <FormGroup className="row mt-0">
                            <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                              End Data Date
                            </Label>
                            <Col sm={8}>
                              <Flatpickr
                                className="form-control d-block"
                                placeholder="Select Date"
                                options={{
                                  altInput: true,
                                  // altFormat: "d/m/Y",
                                  altFormat: "d/m/Y",
                                  dateFormat: "d/m/Y",
                                }}
                              // onChange={(value) => {
                              //   setSearchModel(
                              //     {
                              //       ...searchModel,
                              //       UPLOAD_TO: moment(value[0]).format("YYYY-MM-DD")

                              //     })
                              //   setTempSearch({
                              //     ...tempSearch,
                              //     UPLOAD_TO: value[0]
                              //   })
                              // }}
                              // value={tempSearch.UPLOAD_TO}
                              />
                            </Col>
                          </FormGroup>
                        </Col> */}
                        <Col sm="4">
                          <FormGroup className="row">
                            <div className="d-flex align-items-center justify-content-center">
                              <Button color="info" className="mt-0"
                                onClick={() => onSearch()}
                              >
                                <i className="fas fa-search"></i>
                                &nbsp; Search
                              </Button>

                              <Button color="warning" className="mt-0 ms-2"
                                onClick={() => resetSearch()}
                              >
                                <i className="fas fa-redo-alt"></i>
                                &nbsp; Reset
                              </Button>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>

                      {/* <Row className="mt-5">
                        <Nav tabs>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "1",
                              })}
                              onClick={() => {
                                setActiveTab("1");
                              }}
                            >
                              TPA Balancing & Overuse
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </Row> */}

                      <Row className="mt-3">
                        <hr />
                      </Row>

                      <Row className="mt-2">
                        <Col sm="12">
                          <div>
                            <BootstrapTable
                              id="actual-supply-demand-report-table"
                              keyField="MONTH_NAME"
                              data={modelDeviceList}
                              columns={columns}
                              headerClasses="header-style"
                              rowStyle={rowStyleFontWhite}
                              // defaultSorted={defaultSorted}
                              pagination={paginationFactory(options)}
                            // hover
                            />
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

ActualSupplyDemand.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ ActualSupplyDemand }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ActualSupplyDemand));

// function RenderList(prop) {
//   console.log(prop);

//   return (<tr>
//     <td>{prop.indexlist}</td>
//     <td>{prop.data.MeterPointID}</td>
//     <td>{prop.data.Customer}</td>
//     <td>{prop.data.CustomerType}</td>
//     <td>{prop.data.CommunicationType}</td>
//     <td>{prop.data.Zone}</td>
//     <td>{prop.data.Point}</td>
//     <td>{prop.data.Region}</td>
//     <td>{prop.data.Area}</td>
//     <td>{prop.data.BVZoning}</td>
//     <td>{prop.data.BV}</td>
//     <td>
//       <Button className="me-1"
//         onClick={() =>
//           setPageAdd(true)
//         }
//         color="info"
//       >
//         <i className="far fa-edit"></i>
//         &nbsp; Edit
//       </Button>
//       <Button
//         onClick={() =>
//           setModalDelete(true)
//         }
//         // className="btn-rounded"
//         color="danger"
//       >
//         <i className="fas fa-trash-alt"></i>
//         &nbsp; Delete
//       </Button>
//     </td>
//   </tr>)
// }
